export const CommonService = {
    commonMenuLabel: [],
    getCommonMenuLabel: function (menu, list) {
        menu.forEach(item => {
            if(item.items) {
                list = this.getCommonMenuLabel(item.items, list);
            }

            if(item.table_id && item.table_id !== '' && item.table_id !== "0") {
                list.push(item.table_id);
            } else if(item.ts_name && item.ts_name !== '') {
                list.push(item.ts_name);
            }

        });
        return list;
    },

    generateCommonMenuLabel: function (menu) {
        localStorage.removeItem('commonMenuLabel');
        this.commonMenuLabel = this.getCommonMenuLabel(menu, []);
        localStorage.setItem('commonMenuLabel', this.commonMenuLabel);
    },
};


// WEBPACK FOOTER //
// app/services/main/common.js